export default __webpack_public_path__ + "static/media/art-5-salad-greens.05261a69.jpg";